import React, { useState } from "react";

export default function QuestionItem({ item }) {
  const [answer, setAnswer] = useState(false);

  const showMore = () => {
    setAnswer(!answer);
  };

  return (
    <div
      className={`questionBox ${answer ? "showMore" : ""}`}
      onClick={showMore}>
      <div className='question'>
        <span>{item.question}</span>
        <img src='/public/assets/icons/arrow-down.svg' alt='' />
      </div>

      <div className={`answerBox `}>
        <p className={`answer `}>{item.answer}</p>
      </div>
    </div>
  );
}
